/*
 * @Author: cc
 * @Date: 2021-07-06 16:24:35
 * @LastEditTime: 2022-03-24 11:11:28
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\editingCenter\website\all\allHeadersBtns\allHeaderBtnsDirective.js
 * @Description: 
 */
'use strict';
angular.module('websiteAllModule').directive('allHeaderBtns', ['$state', '$window',
    function($state, $window) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/website/all/allHeadersBtns/index.html',
            replace: false,
            link: function($scope) {
                // $controller('EditShortVideoListCtrl', {$scope: $scope}); // 控制器继承
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return {[type]}   [return description]
                 */
                function initStatus() {
                    Object.assign($scope.data, {
                        btns: [
                            // {
                            //     name: '新建',
                            //     right: 'xinjian',
                            //     noSelect: true, 
                            //     children: [
                            //         {
                            //             name: '新闻',
                            //             oper: $scope.routerToEdit,
                            //             DOCTYPEID: 1
                            //         }, {
                            //             name: '图集',
                            //             oper: $scope.routerToEdit,
                            //             DOCTYPEID: 2
                            //         }, {
                            //             name: '链接',
                            //             oper: $scope.routerToEdit,
                            //             DOCTYPEID: 3
                            //         }, {
                            //             name: '专题',
                            //             oper: $scope.routerToEdit,
                            //             DOCTYPEID: 4
                            //         }, {
                            //             name: '视频',
                            //             oper: $scope.routerToEdit,
                            //             DOCTYPEID: 7
                            //         }
                            //     ]
                            // },
                            {
                                name: '送审',
                                right: 'songshen',
                                oper: $scope.trial,
                            }, {
                                name: '签发',
                                right: 'qianfa',
                                children: [
                                    {
                                        name: '直接签发',
                                        oper: $scope.directSign
                                    }, {
                                        name: '定时签发',
                                        oper: $scope.timeSigned
                                    }
                                ]
                            }, {
                                name: '废稿',
                                right: 'feigao',
                                oper: $scope.waste
                            }, {
                                name: '撤稿',
                                right: 'tuigao',
                                oper: $scope.rejection
                            }, {
                                name: '取消签发',
                                oper: $scope.revoke,
                                right: 'chegao'
                            }, {
                                name: '多签',
                                oper: $scope.multipleSign,
                                right: 'duoqian'
                            }, {
                                name: '修订',
                                oper: $scope.revise,
                                right: 'xiuding'
                            }, {
                                name: '多元分发',
                                right: 'transmit',
                                oper: $scope.distribution
                            }, {
                                name: '排序',
                                html: '<button ng-if="status.isCanMove" class="btn-disabled btn imp_btn btn-default btn-commen web_signed_btn_pixel100 opacity100" ng-click="rank()" ng-disabled="data.selectedArray.length!=1" disabled-tip="请选择且只能选择一篇稿件">排序</button>'
                            }, {
                                name: '置顶',
                                // right: 'zhiding',
                                html: '<button ng-if="status.isCanMove" ng-click="stick()" class="btn-disabled btn btn-default btn-commen opacity100 btn-group2-init-r" ng-disabled="data.selectedArray.length!=1" disabled-tip="请选择且只能选择一篇稿件"><span class="iconfont icon-tuishouye"></span>{{data.selectedArray.length===0||data.selectedArray[0].DOCORDERPRI=="0"?"置顶":"取消置顶"}}</button>'
                            },
                            {
                                name: '导入',
                                right: 'daoru',
                                html: '<button class="btn-disabled btn imp_btn btn-default btn-commen web_signed_btn_pixel100 opacity100" ngf-select ngf-change="draftImport($files, $file, $newFiles)" ng-model="data.file" ngf-validate="{pattern: \'.docx,.doc,.txt\'}">导入</button>'
                            },
                            // {
                            //     name: '固定位置',
                            //     right: 'fixedpostion',
                            //     html: '<button class="btn-disabled btn imp_btn btn-default btn-commen web_signed_btn_pixel100 opacity100" ng-click="fixed()" ng-disabled="data.selectedArray.length==0"><span class="iconfont icon-shoucang"></span>{{status.showFixPosition == true || data.selectedArray.length===0 ? "固定位置" : "取消固定"}}</button>'
                            // },
                            {
                                name: '更多',
                                children: [
                                    {
                                        name: '租户间共享',
                                        oper: $scope.tenantManuShare,
                                        right: 'tenantshare' 
                                    },
                                    {
                                        name: '收藏',
                                        right: 'shoucang',
                                        oper: $scope.collect
                                    },
                                    {
                                        name: '关注',
                                        oper: $scope.follow,
                                        right: 'guanzhu'
                                    },
                                    // {
                                    //     name: '导入',
                                    //     right: 'daoru',
                                    //     html: '<a ngf-select ngf-change="draftImport($files, $file, $newFiles)" ng-model="data.file" ngf-validate="{pattern: \'.docx,.doc,.txt\'}">导入</a>'
                                    // },
                                    {
                                        name: '导出',
                                        oper: $scope.export
                                    }, {
                                        name: '邮件外发',
                                        right: 'waifa',
                                        oper: $scope.outSending
                                    }, {
                                        name: '打印',
                                        oper: $scope.print,
                                    }
                                ]
                            }
                        ]
                    });
                }
            }
        };
    }
]).directive('domCompile', ['$compile',
    function($compile) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            replace: true,
            link: function($scope, element, attrs) {
                loadDirective();

                /**
                 * [loadDirective description] 动态加在组件
                 *
                 * @return {[type]}   [return description]
                 */
                function loadDirective() {
                    var html = attrs.domCompileStr;
                    element.append($compile(html)($scope));
                }
            }
        };
    }
]);
